

$(function(){

	var bgMovie = $('#player');

	function background_size_cover(aspectW, aspectH) {
	var windowWidth = $(window).width();
	var windowHeight = $(window).height();

	if(windowWidth / aspectW * aspectH > windowHeight) {
	  var bgWidth = windowWidth;
	  var bgHeight = Math.floor(bgWidth / aspectW * aspectH) + 1;
	  var bgTop = (windowHeight - bgHeight) / 2;
	  var bgLeft = 0;
	} else {
	  var bgHeight = windowHeight;
	  var bgWidth = Math.floor(bgHeight / aspectH * aspectW) + 1;
	  var bgTop = 0;
	  var bgLeft = (windowWidth - bgWidth) / 2;
	}
	bgMovie.css({
	  top: bgTop,
	  left: bgLeft,
	  width: bgWidth,
	  height: bgHeight
	})
	}
	background_size_cover(1920, 1080);

	$(window).on('resize', function() {
		background_size_cover(1920, 1080);
	});


	$('.event-tab ul li a').click(function(){
		$('.event-tab ul li .active').removeClass('active');
		$(this).addClass('active');

		$('.event-wrap').animate({
			"opacity": 0
		}, 10);
		$('.event-wrap .event-entry').hide();

		if($(this).hasClass('nav-page')){
			$('.event-wrap .race').show();
			$('.event-wrap').animate({
				"opacity": 1
			}, 400);
		} else {
			$('.event-wrap .fun').show();
			$('.event-wrap').animate({
				"opacity": 1
			}, 450);
		}
		return false;
	});

	$(window).on("scroll", function() {

        if ($(this).scrollTop() > 300) {
            $('.pagetop').slideDown("fast");
            $('#sticky_footer').stop().animate({bottom: 0}, 200);
        } else {
            $('.pagetop').slideUp("fast");
            $('#sticky_footer').stop().animate({bottom: -64}, 200);
        }

        scrollHeight = $(document).height();
        scrollPosition = $(window).height() + $(window).scrollTop();
        footHeight = $("#footer").innerHeight();

       var windowWidth = $(window).width();

        if ( scrollHeight - scrollPosition  <= footHeight ) {

            if ( windowWidth > 960) {
	            $(".pagetop").css({
	                "position":"absolute",
	                "bottom": footHeight
	            });
            } else {
	            $(".pagetop").css({
	                "position":"fixed",
	                "bottom": "0"
	            });
            }
        } else {
            $(".pagetop").css({
                "position":"fixed",
                "bottom": "0"
            });
        }

    });

    $('.pagetop').click(function () {
        $('body,html').animate({
        scrollTop: 0
        }, 400);
        return false;
     });


	$('.slide').slick({
		infinite: false,
		dots: false,
	});
	// $('.products').slick({
	// 	infinite: false,
	// 	dots: false,
	// });

	$('.products-orange').slick({
		infinite: false,
		dots: false,
	});
	$('.products-yellow').slick({
		infinite: false,
		dots: false,
	});
	$('.products-blue').slick({
		infinite: false,
		dots: false,
	});
	$('.products-pink').slick({
		infinite: false,
		dots: false,
	});


	$('.event-slide').slick({
		infinite: true,
		dots: false,
		slidesToShow: 1,
		centerMode: true,
		variableWidth: true,
		arrows: true,
	});

	$('.about-navi li').on('click', function(){

		var index = $('.about-navi li').index(this);
		if ( index == 0 ) {
			$('.about-navi li').removeClass('active')
			$('.about-navi li').eq(0).addClass('active')
			$('#about .slick-prev').click();
		} else {
			$('.about-navi li').removeClass('active')
			$('.about-navi li').eq(1).addClass('active')
			$('#about .slick-next').click();
		}

	});

	$('.orange .switch').on('click', function(){
		if ($(this).hasClass("active")) {
			$('.orange .switch').removeClass('active')
			$('.orange .slick-prev').click();
		} else {
			$('.orange .switch').addClass('active')
			$('.orange .slick-next').click();
		}
	});

	$('.blue .switch').on('click', function(){
		if ($(this).hasClass("active")) {
			$('.blue .switch').removeClass('active')
			$('.blue .slick-prev').click();
		} else {
			$('.blue .switch').addClass('active')
			$('.blue .slick-next').click();
		}
	});

	$('.yellow .switch').on('click', function(){
		if ($(this).hasClass("active")) {
			$('.yellow .switch').removeClass('active')
			$('.yellow .slick-prev').click();
		} else {
			$('.yellow .switch').addClass('active')
			$('.yellow .slick-next').click();
		}
	});

	$('.pink .switch').on('click', function(){
		if ($(this).hasClass("active")) {
			$('.pink .switch').removeClass('active')
			$('.pink .slick-prev').click();
		} else {
			$('.pink .switch').addClass('active')
			$('.pink .slick-next').click();
		}
	});

$(window).on("load", function(){

    $(".point-height").heightLine({
        minWidth:768
    });
    /*
    $(".about-inner").heightLine({
        minWidth:992
    });
    */
    $("#spec ul li span").heightLine({
        minWidth:992
    });
    $(".point-main-inner").heightLine({
        minWidth:768
    });

});


	$('.image-movie .role img').velocity(
	    {
	        rotateZ: '+=360deg'
	    }, {
	        duration: 15000,
	        easing: 'linear',
	        loop:true
	    }
	);

	$('#point .point-main .switch').on('click', function(){

		if ($(this).hasClass("active")) {
			$(this).removeClass('active')
			$('#point .point-main .running').css('opacity',1);
			$('#point .point-main .pedal').css('opacity',0);
		} else {
			$(this).addClass('active')
			$('#point .point-main .running').css('opacity',0);
			$('#point .point-main .pedal').css('opacity',1);
		}

	});

	$('#event .event-read-more').on('click', function(){

		$(this).hide();
		$('#event .event-archive').show()

	});

	$('.slider').slick({
		dots: true,
		infinite: true,
		arrows: true,
		speed: 300,
		slidesToShow:3,
		centerMode: true,
		variableWidth: true,
		swipe: true,
    swipeToSlide: true,
    touchMove: true
	});

	$('.bg-slider').slick({
		dots: false,
		infinite: true,
		arrows: false,
		speed: 300,
		slidesToShow:1,
		fade: true,
	});
	$('.color-field-bike').slick({
		dots: false,
		infinite: true,
		arrows: false,
		speed: 300,
		//fade: true,
		slidesToShow:1
	});


	$(".color ul li").on("click", function() {
		var index = $('.color ul li').index(this);
		$(".color ul li").removeClass("active");
		$(this).addClass("active");
		$(".color dt span").removeClass("active");
		$(".color dt span").eq(index).addClass("active");
		$('.color-field-bike').slick('slickGoTo', index);
	});

	$(".filed ul li").on("click", function() {
		var index = $('.filed ul li').index(this);
		$(".filed ul li").removeClass("active");
		$(this).addClass("active");
		$(".filed dt span").removeClass("active");
		$(".filed dt span").eq(index).addClass("active");
		$('.bg-slider').slick('slickGoTo', index);
	});

	$('a[href^="#"]').click(function(){
		var speed = 400;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});

	$(".gnav-toggle").on("click", function() {
		if ($(this).hasClass("toggle-on")) {
			$(this).stop().removeClass("toggle-on");
			$("#gnav-menu").stop().removeClass("menu_on");
			$//("#gnav-menu").fadeOut(200),function(){ $("#gnav-menu").hide(); }
		} else {
			$(this).stop().addClass("toggle-on");
			$("#gnav-menu").stop().addClass("menu_on");
			//$("#gnav-menu").show();
			//$("#gnav-menu").fadeIn(200);
		}
	});

	$("#gnav-menu-body ul li a").on("click", function() {
		$(".gnav-toggle").click();
	});


});
